/**
 * Global Material Swatch Handler
 * Handles material swatch clicks across the entire website
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initializeGlobalMaterialSwatches();
  });

  // Global material swatch functionality
  function initializeGlobalMaterialSwatches() {
    // Use event delegation for all material swatches on the page
    document.addEventListener('click', function(e) {
      if (e.target.closest('.spc-prd-swatch-block')) {
        const swatchBlock = e.target.closest('.spc-prd-swatch-block');
        const productCard = swatchBlock.closest('.main-prd-card');
        
        if (productCard) {
          handleMaterialSwatchClick(swatchBlock, productCard);
        }
      }
    });
  }

  function handleMaterialSwatchClick(swatchBlock, productCard) {
    const currentMaterial = swatchBlock.getAttribute('data-current-material');
    const targetMaterial = swatchBlock.getAttribute('data-material');


    // Update active class for visual feedback only
    updateActiveSwatch(productCard, swatchBlock);

    // Get product handle from the product card
    // First try data-product-handle (mobile popup), then product link
    const dataProductHandle = productCard.getAttribute('data-product-handle');
    const productLink = productCard.querySelector('.product-link');
    
    
    let productHandle;
    if (dataProductHandle) {
      productHandle = dataProductHandle;
    } else if (productLink) {
      // Check for data-url first (mobile popup), then href
      const dataUrl = productLink.getAttribute('data-url');
      const href = productLink.getAttribute('href');
      
      if (dataUrl) {
        productHandle = dataUrl.replace('/products/', '');
      } else if (href) {
        productHandle = href.replace('/products/', '');
      } else {
        return;
      }
      // The card link now carries the selected variant (…?variant=123) and may
      // be an absolute path (/en-au/products/…); reduce it to a bare handle, or
      // product(handle:) resolves to null and the image never updates.
      productHandle = productHandle.split('?')[0].split('#')[0];
      if (productHandle.indexOf('/') > -1) {
        productHandle = productHandle.substring(productHandle.lastIndexOf('/') + 1);
      }
    } else {
      // Last resort: try to extract from popup title or other sources
      const popupTitle = productCard.querySelector('.product-title');
      if (popupTitle) {
        // Try to construct handle from title (this is a fallback)
        const title = popupTitle.textContent.trim().toLowerCase();
        const handle = title.replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
        productHandle = handle;
      } else {
        return;
      }
    }
    
    
    // Generate new handle with different material
    const newHandle = generateNewHandle(productHandle, currentMaterial, targetMaterial);
    
    // Fetch media for new material
    fetchProductMedia(newHandle, productCard, currentMaterial, targetMaterial);
  }

  function updateActiveSwatch(productCard, clickedSwatch) {
    // Remove active class from all swatch blocks in this product card
    const swatchBlocks = productCard.querySelectorAll('.spc-prd-swatch-block');
    swatchBlocks.forEach(block => {
      block.classList.remove('spc-prd-swatch-block-ac');
    });
    
    // Add active class to clicked swatch
    clickedSwatch.classList.add('spc-prd-swatch-block-ac');
  }

  function generateNewHandle(currentHandle, currentMaterial, targetMaterial) {
    // Legacy products carried the material in the handle
    // ("…-14k-white-gold-lab-diamond") and switched to a sibling product on
    // swatch click. Current catalogs (eternity, wedding bands, the rebuilt
    // engagement collections) hold material as a variant option, so the handle
    // has no material to swap — and on those cards data-current-material can be
    // empty. Guard against that: String.replace('', x) prepends x and yields a
    // handle that 404s. When there's nothing to replace, keep the same product;
    // the metal-specific image is then picked in updateProductImages.
    if (!currentMaterial) return currentHandle;
    return currentHandle.replace(currentMaterial, targetMaterial);
  }

  function fetchProductMedia(handle, productCard, currentMaterial = null, targetMaterial = null) {
    
    const query = `
      query ProductMedia($handle: String!) {
        product(handle: $handle) {
          title
          handle
          media(first: 50) {
            nodes {
              mediaContentType
              previewImage {
                url
                altText
              }
              ... on MediaImage {
                id
                image {
                  url
                  altText
                }
              }
              ... on Video {
                sources {
                  url
                  mimeType
                }
              }
              ... on Model3d {
                sources {
                  url
                  format
                }
              }
              ... on ExternalVideo {
                embeddedUrl
              }
            }
          }
        }
      }
    `;

    fetch('/api/2025-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Storefront-Access-Token': window.ShopifyStorefrontToken || '5e6dfd90330910f5f49c5d60ecfb4ddf',
      },
      body: JSON.stringify({
        query: query,
        variables: { handle: handle },
      }),
    })
    .then(response => response.json())
    .then(data => {
      if (data.errors) {
        console.error('GraphQL Errors:', data.errors);
        return;
      }
      
      if (data.data && data.data.product) {
        if (data.data.product.media) {
          updateProductImages(productCard, data.data.product.media.nodes, targetMaterial);
        }
      } else {
        // Try fallback: find similar product with different approach
        // tryFallbackProductSearch(productCard, handle, currentMaterial, targetMaterial);
      }
    })
    .catch(error => {
      console.error('Fetch error:', error);
    });
  }

  function handleProductNotFound(productCard, attemptedHandle) {
    // Show a temporary message that this material is not available
    showMaterialNotAvailableMessage(productCard);
  }

  function showMaterialNotAvailableMessage(productCard) {
    const imageSlider = productCard.querySelector('.product-image-slider');
    if (!imageSlider) return;
    
    // Create a temporary overlay message
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.8);
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      text-align: center;
      z-index: 10;
      border-radius: 8px;
    `;
    overlay.innerHTML = `
      <div>
        <div>Material not available</div>
        <div style="font-size: 12px; margin-top: 4px; opacity: 0.8;">Please try another option</div>
      </div>
    `;
    
    // Make sure the slider container has relative positioning
    const sliderContainer = imageSlider.closest('.main-prd-card-img');
    if (sliderContainer) {
      sliderContainer.style.position = 'relative';
      sliderContainer.appendChild(overlay);
      
      // Remove the message after 2 seconds
      setTimeout(() => {
        if (overlay.parentNode) {
          overlay.parentNode.removeChild(overlay);
        }
      }, 2000);
    }
  }

  // The preset catalogs (Moissanite, Lab Diamond) were rebuilt so material is
  // a variant option, not part of the handle — every product carries all three
  // metals as separate images (…-WG_…, …-YG_…, …-RG_… in the filename). The old
  // generateNewHandle swap is now a no-op, so a swatch click re-fetches the same
  // product and would otherwise dump all three colours into the slider. Narrow
  // to just the clicked metal's image.
  function metalTokenOf(material) {
    var m = (material || '').toLowerCase();
    if (m.indexOf('white') > -1) return 'WG';
    if (m.indexOf('yellow') > -1) return 'YG';
    if (m.indexOf('rose') > -1) return 'RG';
    return null;
  }
  function imageMatchesMetal(url, token) {
    return new RegExp('-' + token + '[_-]', 'i').test(url || '');
  }

  function updateProductImages(productCard, mediaNodes, targetMaterial) {
    // Try different selectors for mobile popup vs regular product card
    let imageSlider = productCard.querySelector('.product-image-slider');
    let sliderCounter = productCard.querySelector('.total-count');
    
    // If not found, try popup-specific selectors
    if (!imageSlider) {
      imageSlider = productCard.querySelector('.popup-image-slider');
    }
    
    if (!sliderCounter) {
      sliderCounter = productCard.querySelector('.popup-total-count');
    }
    
    if (!imageSlider || !sliderCounter) {
      return;
    }

    // Filter only image media
    let imageMedia = mediaNodes.filter(media => media.mediaContentType === 'IMAGE');

    // Keep only the clicked metal's image when it can be identified; if nothing
    // matches (e.g. a legacy product whose filenames aren't metal-tagged), fall
    // back to the full set rather than blanking the card.
    var token = metalTokenOf(targetMaterial);
    if (token) {
      var matched = imageMedia.filter(function (media) {
        var url = media.image ? media.image.url : (media.previewImage ? media.previewImage.url : '');
        return imageMatchesMetal(url, token);
      });
      if (matched.length > 0) imageMedia = matched;
    }

    if (imageMedia.length === 0) return;

    // Update slider counter
    sliderCounter.textContent = imageMedia.length;

    // Clear existing images
    imageSlider.innerHTML = '';

    // Add new images - check if it's popup or regular card
    const isPopup = imageSlider.classList.contains('popup-image-slider');
    
    imageMedia.forEach((media, index) => {
      const imageUrl = media.image ? media.image.url : media.previewImage.url;
      const altText = media.image ? media.image.altText : media.previewImage.altText || '';
      
      if (isPopup) {
        // Popup structure
        const slideContainer = document.createElement('div');
        slideContainer.className = 'popup-slide-container';
        
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = altText;
        img.className = 'popup-slide-img';
        img.loading = 'eager';
        
        slideContainer.appendChild(img);
        imageSlider.appendChild(slideContainer);
      } else {
        // Regular card structure
        const imageDiv = document.createElement('div');
        imageDiv.className = 'bg-product-card-image';
        
        const img = document.createElement('img');
        img.src = imageUrl;
        img.alt = altText;
        img.className = 'ab-img';
        if (index === 0) img.classList.add('active');
        
        imageDiv.appendChild(img);
        imageSlider.appendChild(imageDiv);
      }
    });

    // Reset slider to first image and update counter
    if (isPopup) {
      // For popup, reset the slider index
      imageSlider.style.setProperty('--current-image-index', '0');
      
      // Update popup counter
      const currentIndexElement = productCard.querySelector('.popup-current-index');
      if (currentIndexElement) {
        currentIndexElement.textContent = '1';
      }
      
      // Re-initialize slider for popup
      if (typeof window.initSlider === 'function') {
        window.initSlider(productCard);
      }
    } else {
      // For regular cards, manage active classes
      const firstImage = imageSlider.querySelector('.ab-img');
      if (firstImage) {
        // Remove active class from all images
        imageSlider.querySelectorAll('.ab-img').forEach(img => img.classList.remove('active'));
        // Add active class to first image
        firstImage.classList.add('active');
      }
    }

    // Reinitialize slider after updating images
    if (window.reinitializeSliders) {
      window.reinitializeSliders();
    }

    // Reset slider to first image after reinitialization
    setTimeout(() => {
      const sliderId = imageSlider.getAttribute('data-slider-id');
      if (sliderId && window.sliderStates) {
        const state = window.sliderStates.get(sliderId);
        if (state) {
          state.currentIndex = 0;
          state.$slider[0].style.setProperty('--current-image-index', '0');
          if (state.updateCounter) {
            state.updateCounter();
          }
        }
      }
    }, 100);
  }

  // Fallback function to try different approaches when product not found
  function tryFallbackProductSearch(productCard, attemptedHandle, currentMaterial, targetMaterial) {
    
    // Try 1: Search by collection and material
    const collectionQuery = `
      query SearchByMaterial($material: String!) {
        products(first: 10, query: $material) {
          edges {
            node {
              id
              title
              handle
              media(first: 10) {
                nodes {
                  mediaContentType
                  previewImage {
                    url
                    altText
                  }
                  ... on MediaImage {
                    image {
                      url
                      altText
                    }
                  }
                }
              }
            }
          }
        }
      }
    `;

    const searchQuery = `title:*${targetMaterial}* OR handle:*${targetMaterial}*`;
    
    fetch('/api/2025-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({
        query: collectionQuery,
        variables: { material: searchQuery },
      }),
    })
    .then(response => response.json())
    .then(data => {
      if (data.data && data.data.products && data.data.products.edges.length > 0) {
        // Find the most similar product
        const similarProduct = data.data.products.edges[0].node;
        
        if (similarProduct.media && similarProduct.media.nodes.length > 0) {
          updateProductImages(productCard, similarProduct.media.nodes);
        }
      } else {
        // Show message that this material is not available
        showMaterialNotAvailableMessage(productCard, targetMaterial);
      }
    })
    .catch(error => {
      console.error('Fallback search error:', error);
      showMaterialNotAvailableMessage(productCard, targetMaterial);
    });
  }

  // Show message when material is not available
  function showMaterialNotAvailableMessage(productCard, material) {
    // You can add a visual indicator here
    // For now, just silently handle the unavailable material
    const materialName = material.replace('14k-', '').replace('-', ' ').toUpperCase();
  }

  // Expose functions globally for mobile popup
  window.handleMaterialSwatchClick = handleMaterialSwatchClick;
  window.updateActiveSwatch = updateActiveSwatch;

})();
